import type { FC } from 'react';

import { blockEvent } from '../../utils/helpers';
import { Loader } from '../Loader/Loader';

import styles from './DialogLoader.module.scss';

export const DialogLoader: FC<{ isProcessing?: boolean }> = ({ isProcessing }) =>
  isProcessing ? (
    <div className={styles.loaderWrapper} onClick={blockEvent}>
      <Loader />
    </div>
  ) : null;
